import React, { useState } from 'react';
import Tabs from './ui/Tabs';
import Topbar from './ui/Topbar';
import ClientList from './ClientList';
import B2BTab from './B2BTab';
import AppTab from './AppTab';
import ParametrosTab from './ParametrosTab';

type TabId = 'clientes' | 'b2b' | 'app' | 'parametros';

const Home: React.FC = () => {
  const [tab, setTab] = useState<TabId>('clientes');

  return (
    <div className="screen active has-sticky-footer">
      <Topbar
        title="Consulta de clientes"
      />

      <Tabs
        items={[
          {
            id: 'clientes',
            label: (
              <>
                <span className="icon-s icon-agenda" />
                <span>Clientes</span>
              </>
            ),
          },
          {
            id: 'b2b',
            label: (
              <>
                <span className="icon-s icon-backoffice" />
                <span>B2B</span>
              </>
            ),
          },
          {
            id: 'app',
            label: (
              <>
                <span className="icon-s icon-movil" />
                <span>APP</span>
              </>
            ),
          },
          {
            id: 'parametros',
            label: (
              <>
                <span className="icon-s icon-opciones" />
                <span>Parámetros</span>
              </>
            ),
          },
        ]}
        value={tab}
        onChange={setTab}
      />

      {tab === 'clientes' ? (
        <ClientList embedded />
      ) : tab === 'b2b' ? (
        <B2BTab />
      ) : tab === 'app' ? (
        <AppTab />
      ) : (
        <ParametrosTab />
      )}
    </div>
  );
};

export default Home;
